// extracted by mini-css-extract-plugin
export default {"root":"EmptyStub_root__t50Wz","image":"EmptyStub_image__QRMgO","text":"EmptyStub_text__tvqX-","placeHolderShimmer":"EmptyStub_placeHolderShimmer__KcpFj"};